export default __webpack_public_path__ + "static/media/PXL_20230701_144616464.MP.d162f303.jpg";